import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

const TipoDetraccionFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue, handleChange }) => {
  const [listaDetracciones, setListaDetracciones] = React.useState([])

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.DETRACCION).then(({ data }) => {
      setListaDetracciones(data)
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='TIPO' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='tipoDetraccion'>
          {({ field }) => (
            <Form.Select {...field} id='select-tipoDetraccion' isInvalid={iError && iTouched} disabled={fIsSubmitting}>
              <option value=''>Seleccionar</option>
              {listaDetracciones.map((x, k) => (
                <option key={k} value={x._id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDetraccionFormGroup)
